import { googleLogout } from '@react-oauth/google';

/** Release Google Identity Services popups/iframes that block clicks after redirect. */
export function cleanupGoogleSignInOverlays() {
  try {
    googleLogout();
  } catch {
    /* GIS may be unavailable when client ID is unset */
  }

  document
    .querySelectorAll('#credential_picker_container, iframe[src*="accounts.google.com"]')
    .forEach((el) => {
      if (typeof el.remove === 'function') {
        el.remove();
      } else {
        el.style.pointerEvents = 'none';
        el.style.display = 'none';
      }
    });

  window.focus();
}
